import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function Card3Judgement() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
   const VIDEO_ID = "3cardj"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
     <CasinoPage
              casino={casinoData?.data}
              VIDEO_ID={VIDEO_ID}
              // VIDEO_ID={GAME_ID}
              GAME_ID={GAME_ID}
              // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
              //  VIDEO_ID={GAME_ID}
              // GAME_ID={GAME_ID}
              // shortName={"cards32a cards32b"}
              // gameName={"CARDS 32B"}
            >
    {/* <div className="center-main-container casino-page"> */}
    {/* <div className="center-container"> */}
      {/* <div className="casino-page-container threecardj"> */}
        {/* <div className="casino-header"> */}
          {/* <span className="casino-name">3 Cards Judgement</span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>128250430174819</span>
            </small>
          </span> */}
        {/* </div> */}
        {/* <div className="casino-title-header-mobile d-xl-none">
          <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>128250430174819</span>
            </span>
          </div>
        </div> */}
        {/* <div className=""> */}
          {/* <div className="casino-video"> */}
            {/* <div className="video-box-container"> */}
              {/* <div className="casino-video-box"> */}
                {/* <iframe src="/mediaplayer/3cardj/108f64ad-bdc5-4a3d-b5bf-dde8fd2918c6?ip=122.160.119.41" /> */}
              {/* </div> */}
            {/* </div> */}
            {/* <div className="casino-video-cards">
              <div className="">
                <div className="flip-card-container">
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                  <div className="flip-card">
                    <div className="flip-card-inner ">
                      <div className="flip-card-front">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                      <div className="flip-card-back">
                        <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/1.jpg" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
          {/* </div> */}
          <div className="casino-detail">
            <div className="casino-table">
              <div className="threecardjbox back">
                <div className="threecard-title">
                  Yes
                    {/* {getOddForEntity("Yes", casinoData, true)} */}
                  <div className="casino-odds" />
                </div>
                <div className="threecardj-cards">
                  <h4 className="text-center w-100 mb-2">
                    <b>  {getOddForEntity("Yes", casinoData, true)}</b>
                  </h4>
                  <div className="card-odd-box">
                    {/* <div className=""> */}
                    <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/1.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/2.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/3.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/4.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/5.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/6.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/7.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/8.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/9.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/10.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/11.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/12.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box back  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/13.jpg" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="threecardjbox lay">
                <div className="threecard-title">
                  No
                  <div className="casino-odds" />
                </div>
                <div className="threecardj-cards">
                  <h4 className="text-center w-100 mb-2">
                  <b>  {getOddForEntity("No", casinoData, true)}</b>
                  </h4>
                  <div className="card-odd-box">
                    {/* <div className=""> */}
                    <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/1.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/2.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/3.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/4.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/5.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/6.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/7.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/8.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/9.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/10.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/11.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                  <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/12.jpg" />
                    </div>
                  </div>
                  <div className="card-odd-box">
                     <div
                className={`casino-odds-box lay  ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`} >
                      <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/andar-bahar-cards/13.jpg" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="casino-remark mt-1">
                <marquee scrollamount={3}>
                  Select any 3 card and you will win if you will get at least 1
                  card from the 3 cards you have selected.|Select any 3 card and
                  you will win If you do not get any card from the 3 cards you
                  have selected.
                </marquee>
              </div>
            </div>
            {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/3cardj">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div> */}
          </div>
        {/* </div> */}
        <div className="d-none">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      {/* </div> */}
    {/* </div> */}
    {/* <div className="sidebar right-sidebar casino-right-sidebar sticky">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
  {/* </div> */}
  </CasinoPage>
  

  );
}
